<ng-container [ngSwitch]="getComponentRenderState()">
  <ng-container *ngSwitchCase="'content'">
    <div
      class="clickable-area hover-tile rounded-md w-full cursor-pointer focus-link"
      (click)="redirectToCheckout()">
      <div class="loyalty-program-image-container mt-6">
        <img
          *ngIf="loyaltyProgramImageUrl()"
          class="loyalty-program-image"
          alt=""
          [src]="loyaltyProgramImageUrl()" />
      </div>

      <h2 class="loyalty-program-name mx-4 mt-6 mb-4">
        {{ loyaltyProgram.name }}
      </h2>

      <div class="button-container rounded-md-b py-6">
        <rd-shared-button
          class="loyalty-program-link"
          [ariaLabel]="
            'accessibility.transfer_v2.select'
              | translate: { item: loyaltyProgram.name }
          "
          [buttonClass]="'loyalty-program-link'"
          [buttonContent]="buttonContent"
          [buttonTheme]="'secondary'">
          <ng-template #buttonContent>
            {{ 'transfer.programs.select' | translate }}
          </ng-template>
        </rd-shared-button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'loading'">
    <div class="loading">
      <div class="loyalty-program-image-container mt-6">
        <div class="loyalty-program-image"></div>
      </div>
      <div class="loyalty-program-name mx-4 mt-6 mb-4"></div>
      <div class="button-container py-6">
        <div class="loyalty-program-link button-height"></div>
      </div>
    </div>
  </ng-container>
</ng-container>
